import { render, staticRenderFns } from "./processUnit.vue?vue&type=template&id=b008402a"
import script from "./processUnit.vue?vue&type=script&lang=js"
export * from "./processUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b008402a')) {
      api.createRecord('b008402a', component.options)
    } else {
      api.reload('b008402a', component.options)
    }
    module.hot.accept("./processUnit.vue?vue&type=template&id=b008402a", function () {
      api.rerender('b008402a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/processUnit.vue"
export default component.exports